// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tlHP","content":"styles_content__23yA7","tableWrap":"styles_tableWrap__4iIB6"};